import { Box, Button, Stack, Typography } from "@mui/material"
import { QueuePlayNext } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { useAppDispatch } from "../app/hooks"
import RafflesList from "../features/raffles-list/components/raffles-list"
import { useEffect } from "react"
import { getRafflesThunk } from "../features/raffles-list/rafles-list.slice"
import { clearCurrentRaffleAct } from "../features/raffles/handle-raffle.slice"
import DisableRaffleDialog from "../features/raffles-list/components/disable-raffle-dialog"
import DialogSureNumberWinners from "../features/raffles-list/components/dialog-sure-number-winners"
import Title from "../features/dashboard/components/Title"

export default function RafflesListView() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(getRafflesThunk())
    dispatch(clearCurrentRaffleAct())
  }, [])

  const handleCreateRaffle = () => {
    dispatch(clearCurrentRaffleAct())
    navigate("/dashboard/create-raffle")
  }

  return (
    <Stack spacing={1.5}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Box>
          <Title>Sorteos</Title>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.3 }}>
            Gestiona sorteos activos, configuración y ganadores seguros.
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="small"
          startIcon={<QueuePlayNext />}
          onClick={handleCreateRaffle}
          sx={{ alignSelf: { xs: "stretch", sm: "auto" }, cursor: "pointer", whiteSpace: "nowrap" }}
        >
          Nuevo sorteo
        </Button>
      </Box>

      <RafflesList />
      <DisableRaffleDialog />
      <DialogSureNumberWinners />
    </Stack>
  )
}
